<template>
  <span style="display: inline-block; min-width: 96px;">
    <b-badge :variant="capitalizeIntoCost ? 'primary' : 'secondary'">
      {{ capitalizeIntoCost ? translations.txtAdjustmentCapitalized : translations.txtAdjustmentPassThrough }}
    </b-badge>
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AdjustmentTypeCapitalizeBadge',
  props: {
    capitalizeIntoCost: { type: Boolean, default: false }
  },
  computed: {
    ...mapState(['translations'])
  }
}
</script>
